import { render, staticRenderFns } from "./CleaningForm1.vue?vue&type=template&id=90ee9844"
import script from "./CleaningForm1.vue?vue&type=script&lang=js"
export * from "./CleaningForm1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports